import {
  DEEP_LINK_SUB_LOCATION,
  DEEP_LINK_LOCATION_IN_GAME,
  DEEP_LINK_REWARD_PACKAGES,
  DEEP_LINK_MULTI_REDEMPTIONS,
  DEEP_LINK_MAX_REDEMPTIONS,
  DEEP_LINK_AUDIENCES,
  DEEP_LINK_TARGET_USERS,
} from './DeepLink';
import {
  AFFILIATE,
  APPLICATION,
  CAMPAIGNS,
  CONVERSION_PAGE_FLOW,
  CONVERSION_PAGES,
  DEEP_LINK,
  LOCALE,
  NETWORK,
  PLATFORM,
  PROMO_CODE,
  RE_ENGAGEMENT,
  REWARD_PACKAGE,
  ADDITIONAL_REWARD_PACKAGE,
  ADDITIONAL_REWARD_CONDITION,
  LINKS_CONFIG,
  CONVERSION_PAGE_ID,
  DOMAIN,
} from './constants';

export const DEPENDENCIES = {
  [RE_ENGAGEMENT]: [APPLICATION, AFFILIATE],
  [APPLICATION]: [],
  [DEEP_LINK_REWARD_PACKAGES]: [APPLICATION],
  [NETWORK]: [APPLICATION],
  [DOMAIN]: [APPLICATION, PLATFORM, NETWORK],
  [CONVERSION_PAGE_FLOW]: [APPLICATION, PLATFORM, NETWORK, DOMAIN],
  [LOCALE]: [APPLICATION, PLATFORM, NETWORK, DOMAIN],
  [PLATFORM]: [NETWORK],
  [CONVERSION_PAGE_ID]: [APPLICATION],
  [DEEP_LINK_AUDIENCES]: [APPLICATION],
  [DEEP_LINK_MULTI_REDEMPTIONS]: [
    `${DEEP_LINK}.${DEEP_LINK_REWARD_PACKAGES}`,
    `${DEEP_LINK}.${DEEP_LINK_TARGET_USERS}`,
  ],
  [DEEP_LINK_MAX_REDEMPTIONS]: [`${DEEP_LINK}.${DEEP_LINK_MULTI_REDEMPTIONS}`],
  [CONVERSION_PAGES]: [
    CONVERSION_PAGE_FLOW,
    LOCALE,
    PLATFORM,
    APPLICATION,
    DOMAIN,
  ],
  [CAMPAIGNS]: [PLATFORM],
  [DEEP_LINK]: [PLATFORM, APPLICATION, RE_ENGAGEMENT, AFFILIATE, NETWORK],
  [DEEP_LINK_SUB_LOCATION]: [`${DEEP_LINK}.${DEEP_LINK_LOCATION_IN_GAME}`],
  [PROMO_CODE]: [APPLICATION, PLATFORM],

  [REWARD_PACKAGE]: [APPLICATION],
  [ADDITIONAL_REWARD_PACKAGE]: [APPLICATION],
  [ADDITIONAL_REWARD_CONDITION]: [APPLICATION],
  [DEEP_LINK_LOCATION_IN_GAME]: [
    APPLICATION,
    `${DEEP_LINK}.${DEEP_LINK_REWARD_PACKAGES}`,
  ],
  [LINKS_CONFIG]: [PLATFORM, APPLICATION, AFFILIATE, NETWORK, RE_ENGAGEMENT],
};
